import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { projectsApi, type Project } from '../services/api';

interface ProjectState {
  activeProjectId: number | null;
  projects: Project[];
  loading: boolean;
  error: string | null;

  setActiveProject: (id: number | null) => void;
  refresh: () => Promise<void>;
  getActiveProject: () => Project | null;
}

export const useProjectStore = create<ProjectState>()(
  persist(
    (set, get) => ({
      activeProjectId: null,
      projects: [],
      loading: false,
      error: null,

      setActiveProject: (id) => set({ activeProjectId: id }),

      refresh: async () => {
        set({ loading: true, error: null });
        try {
          const projects = await projectsApi.list();
          set({ projects, loading: false });
          const { activeProjectId } = get();
          if (activeProjectId && !projects.find((p) => p.id === activeProjectId)) {
            set({ activeProjectId: null });
          }
        } catch (err) {
          const msg = err instanceof Error ? err.message : 'Failed to load projects';
          set({ error: msg, loading: false });
        }
      },

      getActiveProject: () => {
        const { activeProjectId, projects } = get();
        if (activeProjectId == null) return null;
        return projects.find((p) => p.id === activeProjectId) ?? null;
      },
    }),
    {
      name: 'inverterai-project',
      partialize: (state) => ({ activeProjectId: state.activeProjectId }),
    }
  )
);
